import { Link } from '@tanstack/react-router'
import { useCurrentUser } from '~/lib/auth'
import { Logo } from '~/components/Logo'
import ThemeToggle from '~/components/ThemeToggle'
import { Button } from '~/components/ui/button'

export default function Home() {
  const { data: user } = useCurrentUser()

  return (
    <div className="min-h-screen bg-plane text-ink">
      <header className="mx-auto flex max-w-5xl items-center justify-between px-6 py-5">
        <Logo />

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <Button asChild size="sm">
            <Link to={user ? '/dashboard' : '/login'}>
              {user ? 'Open dashboard' : 'Sign in'}
            </Link>
          </Button>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-6 py-20">
        <p className="text-sm font-medium text-brand">AI sales agent for education</p>
        <h1 className="mt-3 max-w-2xl text-5xl font-semibold leading-[1.05] tracking-tight">
          Turn registrations into enrolments.
        </h1>
        <p className="mt-5 max-w-xl text-lg text-ink-2">
          Import your student list. The agent starts the conversation, shares demo lectures,
          answers fee and batch questions, and escalates the ones that need a person.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          <Button asChild size="lg">
            <Link to={user ? '/dashboard' : '/login'}>
              {user ? 'Go to dashboard' : 'Get started'}
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline">
            <a href="https://vite-ruby.netlify.app/guide/rails">How it is wired</a>
          </Button>
        </div>
      </main>
    </div>
  )
}
